<template>
  <div class="left_block profile">
    <UserInfo @photo="openPhotoModal" @edit="openEditModal" :profile-info="profileInfo" />

    <b-modal :active.sync="emailModal" has-modal-card scroll="keep">
      <EmailModal @close-modal="closeEmailModal" />
    </b-modal>

     <b-modal :active.sync="editModal" has-modal-card scroll="keep">
      <EditModal
        :modal-info="modalInfo"
        @click="updateProfile"
        :new-profile="newProfile"
        @close-modal="closeEditModal"
      />
    </b-modal>

    <b-modal :active.sync="editPhoto" has-modal-card scroll="keep">
      <EditPhoto @save="changePhoto" @close-modal="closePhotoModal" />
    </b-modal>
  </div>
</template>

<script>
import EditPhoto from '@/components/user/profile/EditPhoto'
import EmailModal from '@/components/user/profile/EmailModal'
import EditModal from '@/components/user/profile/EditModal'
import UserInfo from '@/components/user/profile/UserInfo'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    UserInfo,
    EmailModal,
    EditModal,
    EditPhoto
  },
  data() {
    return {
      modalInfo: {
        profileModal: true
      },
      emailModal: false,
      editPhoto: false,
      editModal: false,
      newProfile: this.defaultProfile()
    }
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    }
  },
  methods: {
    defaultProfile() {
      return {
        name: '',
        surname: '',
        branch_id: 0,
        email: '',
        position: '',
        password: '',
        password_confirmation: ''
      }
    },
    loadDataCallBack(data) {
      this.newProfile = this.defaultProfile()
      this.$store.commit('SET_CURRENT_USER', { user: data })
    },
    loadData() {
      this.$axios2
        .get('profile')
        .then((resp) => {
          this.loadDataCallBack(resp.data)
        })
        .catch(this.$errorToast)
    },
    openEmailModal() {
      this.emailModal = true
    },
    openPhotoModal() {
      this.editPhoto = true
    },
    openEditModal() {
      this.editModal = true
    },
    closeEmailModal() {
      this.emailModal = false
    },
     closePhotoModal() {
      this.editPhoto = false
    },
    closeEditModal() {
      this.editModal = false
    },
    changePhoto(file) {
      const fData = new FormData()
      fData.append('image', file)
      this.$axios2
        .post('profile', fData, { headers: { 'content-type': 'multipart/form-data' } })
        .then((resp) => {
          this.closePhotoModal()
          this.loadDataCallBack(resp.data)
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    updateProfile() {
      let request = {
        id: this.profileInfo.id
      }
      Object.keys(this.newProfile).forEach((key) => {
        if (this.newProfile[key]) {
          request[key] = this.newProfile[key]
        }
      })
      if (Object.keys(request).length > 1) {
        this.$axios2
          .post('profile', request)
          .then((resp) => {
            this.closeEditModal()
            this.loadDataCallBack(resp.data)
            this.$buefy.toast.open(toastInfo())
            if (request.email) {
              this.openEmailModal()
            }
          })
          .catch(this.$errorToast)
      }
    }
  }
}
</script>